import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularFireModule } from "@angular/fire";
import { environment } from "src/environments/environment";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTabsModule } from "@angular/material/tabs";
import { AngularFireFunctionsModule, ORIGIN } from "@angular/fire/functions";

import { HttpClientModule } from "@angular/common/http";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import {
  SummaryByProductComponent,
  SummaryByDowComponent,
  SummaryByActiveDaysComponent,
  OrdersTableComponent
} from "../venue/components/tables";
import { MatToolbarModule } from "@angular/material/toolbar";
import { PageHeaderComponent } from "../admin/components/layout/page-header/page-header.component";
import {
  MDBBootstrapModulesPro,
  MDBSpinningPreloader
} from "ng-uikit-pro-standard";
import { MdbCalendarModule } from "mdb-calendar";
import { FilterAnalyticsComponent } from "../admin/components/forms/filter-analytics/filter-analytics.component";
import { FilterOrdersComponent } from "../admin/components/forms/filter-orders/filter-orders.component";
import { ConfirmRedeemComponent } from "./components/popups/confirm-redeem/confirm-redeem.component";
import { ToastModule } from "ng-uikit-pro-standard";
import { WelcomeUserComponent } from "./components/cards/welcome-user/welcome-user.component";
import { PeriodTotalsCardComponent } from "../venue/components/cards/period-totals-card/period-totals-card.component";
import * as admin from "firebase-admin";
import { PushNotificationGalleryComponent } from "./components/popups/push-notification-gallery/push-notification-gallery.component";
import { PushNotificationRecievedComponent } from "./components/popups/push-notification-recieved/push-notification-recieved.component";
import { DateDetailsPopupComponent } from "./components/popups/date-details-popup/date-details-popup.component";
import { CalendarPickerComponent } from "./components/forms/calendar-picker/calendar-picker.component";

@NgModule({
  declarations: [
    SummaryByProductComponent,
    SummaryByDowComponent,
    SummaryByActiveDaysComponent,
    OrdersTableComponent,
    PageHeaderComponent,
    FilterOrdersComponent,
    FilterAnalyticsComponent,
    ConfirmRedeemComponent,
    WelcomeUserComponent,
    PeriodTotalsCardComponent,
    PushNotificationGalleryComponent,
    PushNotificationRecievedComponent,
    DateDetailsPopupComponent,
    CalendarPickerComponent
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    DragDropModule,
    RouterModule,
    FontAwesomeModule,
    MatToolbarModule,
    NgbModule,
    MatTabsModule,
    MDBBootstrapModulesPro.forRoot(),
    // ToastModule.forRoot(),

    MdbCalendarModule
  ],
  providers: [
    MDBSpinningPreloader,
    { provide: ORIGIN, useValue: "http://localhost:4200" }
  ],
  exports: [
    AngularFirestoreModule,
    AngularFireStorageModule,
    MatToolbarModule,
    AngularFireAuthModule,
    OrdersTableComponent,
    FormsModule,
    SummaryByProductComponent,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    AngularFireModule,
    DragDropModule,
    RouterModule,
    FontAwesomeModule,
    NgbModule,
    MatTabsModule,
    FilterOrdersComponent,
    PageHeaderComponent,
    SummaryByDowComponent,
    MDBBootstrapModulesPro,
    MdbCalendarModule,
    SummaryByActiveDaysComponent,
    FilterAnalyticsComponent,
    PushNotificationGalleryComponent,
    WelcomeUserComponent,
    PeriodTotalsCardComponent,
    PushNotificationRecievedComponent,
    DateDetailsPopupComponent,
    CalendarPickerComponent
  ],
  entryComponents: [
    ConfirmRedeemComponent,
    PushNotificationGalleryComponent,
    DateDetailsPopupComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule {}
